import React from 'react';
import PropTypes from 'prop-types';
import { ModalWrapper, ContentTheme } from './hover-context.styled';

const HoverContext = (props) =>
  props.show && (
    <ModalWrapper data-testid="hover-context">
      <ContentTheme>{props.date}</ContentTheme>
    </ModalWrapper>
  );

HoverContext.propTypes = {
  show: PropTypes.bool,
  date: PropTypes.string
};

export default HoverContext;



// WEBPACK FOOTER //
// ./components/line-chart/hover-context/hover-context.js